import React, { useEffect, useState } from "react";
import { MusicInstrumentFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Inputs, Buttons } from "components";
import { useTranslation } from "react-i18next";
import {
  CATE_PRODUCT_OPTION_OBJECT_CASE,
  INSTUMENT_TYPE_OPTIONS,
} from "utils/functions/productBooking";

const MusicInstrumentForm = ({
  initialValues,
  onSubmit,
  onCancel,
  onDelete,
  isEdit,
  onUpdate,
}) => {
  const schema = yup.object().shape({
    // name: yup.string().required("Reward Name is required"),
    // description: yup.string().required("Description Name is required"),
    // type: yup.string().required("Reward Type is required"),
  });

  const {
    control,
    // watch,
    handleSubmit,
    formState: { errors },
    reset,
    // setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { i18n } = useTranslation();

  const [_instrumentType, _setInstrumentType] = useState();

  // const watchCampaignType = watch('type');

  useEffect(() => {
    if (initialValues) {
      _setInstrumentType(initialValues.instrument_type_code_amin);
      reset({
        ...initialValues,
        instrument_type_code_admin: {
          labelEn: initialValues.instrument_type_en_admin,
          labelTh: initialValues.instrument_type_th_admin,
          label: initialValues.instrument_type_th_admin,
          value: initialValues.product_code_admin,
        },
        product_code_admin: {
          labelEn: initialValues.product_en_admin,
          labelTh: initialValues.product_th_admin,
          label: initialValues.product_th_admin,
          value: initialValues.product_code_admin,
        },
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MusicInstrumentFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_title">Out Of Warranty - Music Instrument</div>
        <div className="sub_title">{isEdit ? "EDIT" : "VIEW ONLY"}</div>
        <div className="body_form_campaign">
          <div className="input_type_wrap">
            <div className="itw_left_box">Qwner Name</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.customer_first_name?.message}
                    disabled={isEdit}
                  />
                )}
                name="customer_first_name"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Phone Number</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      errors={errors.customer_phone_number?.message}
                      disabled={isEdit}
                    />
                  )}
                  name="customer_phone_number"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Email</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      errors={errors.customer_email?.message}
                      disabled={isEdit}
                    />
                  )}
                  name="customer_email"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Admin Note</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextArea
                      {...field}
                      disabled
                      errors={errors.admin_note?.message}
                    />
                  )}
                  name="admin_note"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="line" />
          <div className="form_title">
            ข้อมูลที่ ลูกค้ากรอกมา (แสดงข้อมูลนี้ใน SMY Connect ฝั่ง Member)
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">ประเภทเครื่องดนตรี</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.instrument_type_th?.message}
                    disabled={isEdit}
                  />
                )}
                name="instrument_type_th"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">กลุ่มสินค้า</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.product_th?.message}
                    disabled={isEdit}
                  />
                )}
                name="product_th"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Brand</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.brand?.message}
                    disabled={isEdit}
                  />
                )}
                name="brand"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Model</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.model?.message}
                    disabled={isEdit}
                  />
                )}
                name="model"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Series</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.series?.message}
                  />
                )}
                name="series"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Serial No.</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.serial_no?.message}
                  />
                )}
                name="serial_no"
                defaultValue=""
              />
            </div>
          </div>
          <div className="line" />
          <div className="form_title">
            ข้อมูลที่ Admin Clean (แสดงข้อมูลนี้ใน Yamaha Admin เท่านั้น)
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">ประเภทเครื่องดนตรี</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputMultiSelect
                    {...field}
                    value={field.value}
                    options={INSTUMENT_TYPE_OPTIONS.map((e) => ({
                      ...e,
                      label: i18n.language === "en" ? e.labelEn : e.labelTh,
                      value: e.value,
                    }))}
                    placeholder={"เลือกประเภทเครื่องดนตรี"}
                    errors={errors.instrument_type_code_admin?.message}
                    // disabled={initialValues ? true : false}
                    onChange={(e) => {
                      field.onChange(e);
                      _setInstrumentType(e.value);
                    }}
                  />
                )}
                name="instrument_type_code_admin"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">กลุ่มสินค้า</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputMultiSelect
                    {...field}
                    value={field.value}
                    options={CATE_PRODUCT_OPTION_OBJECT_CASE(
                      _instrumentType
                    ).map((e) => ({
                      ...e,
                      label: e.labelTh,
                      value: e.value,
                    }))}
                    placeholder={"เลือกกลุ่มสินค้า"}
                    errors={errors.product_code_admin?.message}
                    onChange={(e) => {
                      field.onChange(e);
                      _setInstrumentType(e);
                    }}
                  />
                )}
                name="product_code_admin"
                // defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Brand</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.brand_admin?.message}
                  />
                )}
                name="brand_admin"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Model</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.model_admin?.message}
                  />
                )}
                name="model_admin"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Series</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.series_admin?.message}
                  />
                )}
                name="series_admin"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Serial No.</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.serial_no_admin?.message}
                  />
                )}
                name="serial_no_admin"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Admin Note</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextArea
                      {...field}
                      errors={errors.admin_note?.message}
                    />
                  )}
                  name="admin_note"
                  defaultValue=""
                />
              </div>
            </div>
          </div>

          <div className="btn_zone">
            <div className="w120">
              <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
            </div>
            {isEdit && (
              <>
                {initialValues && (
                  <div className="w120">
                    <Buttons.BgStandard
                      theme_red
                      label="Delete"
                      onClick={onDelete}
                      disabled={!initialValues}
                    />
                  </div>
                )}
                <div className="w120">
                  <Buttons.BgStandard
                    type="submit"
                    label="Update"
                    // disabled={initialValues && initialValues.is_center}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </form>
    </MusicInstrumentFormStyled>
  );
};

MusicInstrumentForm.propTypes = {};

export default MusicInstrumentForm;
